import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { Button, Stack, Typography } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { varAlpha, hideScrollY } from 'src/theme/styles';
import { toast } from 'src/components/snackbar';

import { Logo } from 'src/components/logo';
import { Scrollbar } from 'src/components/scrollbar';
import { NavSectionMini, NavSectionVertical } from 'src/components/nav-section';
import { useAuthContext } from 'src/auth/hooks';

import { NavToggleButton } from '../components/nav-toggle-button';

import { NavUpgrade } from '../components/nav-upgrade';


// ----------------------------------------------------------------------

export function NavVertical({ sx, data, slots, isNavMini, layoutQuery, onToggleNav, ...other }) {
  const theme = useTheme();
  const { establishment, client } = useAuthContext();

  const renderNavVertical = (
    <>
      {slots?.topArea ?? (
        <Box sx={{ pl: 3.5, pt: 2.5, pb: 1 }}>
          <Logo />
        </Box>
      )}

      <Scrollbar fillContent>
        <NavSectionVertical data={data} sx={{ px: 2, flex: '1 1 auto' }} {...other} />

        {
          !client && (
            <>
              {/* {slots?.bottomArea ?? <NavUpgrade />} */}
              <Stack style={{
                width: "90%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}>
                <Typography variant="body2" sx={{ display: 'none', [theme.breakpoints.up(layoutQuery)]: { display: 'inline-flex' } }}>
                  Compartilhar meu estabelecimento
                </Typography>
                <Button
                  variant="text"
                  sx={{
                    display: 'none',
                    [theme.breakpoints.up(layoutQuery)]: { display: 'inline-flex' },
                    width: 120,
                  }}
                  onClick={() => {
                    // copy link to clipboard
                    navigator.clipboard.writeText(`${window.location.origin}/establishment-page/${establishment?.id}`);
                    toast.success('Link copiado para a área de transferência');
                  }}
                >
                  <Iconify icon="eva:share-outline" width={24} style={{
                    color: theme.palette.primary.main,
                  }} />
                  <Typography variant="body2" sx={{ display: 'none', [theme.breakpoints.up(layoutQuery)]: { display: 'inline-flex' } }}>
                    Compartilhar
                  </Typography>
                </Button>
              </Stack>
            </>
          )
        }
      </Scrollbar>
    </>
  );

  const renderNavMini = (
    <>
      {slots?.topArea ?? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2.5 }}>
          <Logo />
        </Box>
      )}

      <NavSectionMini
        data={data}
        sx={{ pb: 2, px: 0.5, ...hideScrollY, flex: '1 1 auto', overflowY: 'auto' }}
        {...other}
      />

      {slots?.bottomArea}
    </>
  );

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        height: 1,
        display: 'none',
        position: 'fixed',
        flexDirection: 'column',
        // bgcolor: 'var(--layout-nav-bg)',
        bgcolor: 'white',
        zIndex: 'var(--layout-nav-zIndex)',
        width: isNavMini ? 'var(--layout-nav-mini-width)' : 'var(--layout-nav-vertical-width)',
        borderRight: `1px solid var(--layout-nav-border-color, ${varAlpha(theme.vars.palette.grey['500Channel'], 0.12)})`,
        transition: theme.transitions.create(['width'], {
          easing: 'var(--layout-transition-easing)',
          duration: 'var(--layout-transition-duration)',
        }),
        [theme.breakpoints.up(layoutQuery)]: {
          display: 'flex',
        },
        ...sx,
      }}
    >
      <NavToggleButton
        isNavMini={isNavMini}
        onClick={onToggleNav}
        sx={{
          display: 'none',
          [theme.breakpoints.up(layoutQuery)]: {
            display: 'inline-flex',
          },
        }}
      />
      {isNavMini ? renderNavMini : renderNavVertical}
    </Box>
  );
}
